export const aboutEn = {
  embed: {
    cards: [
      { title: 'Our Mission', desc: 'To offer the best experience in buying and selling vehicles, with transparency and trust in every transaction.' },
      { title: 'Trust', desc: 'We stand out for our honesty and transparency in every transaction. Your satisfaction is our priority.' },
      { title: 'Excellence', desc: 'Continuous improvement in our processes to ensure top-level service for all our clients.' },
    ],
    teamTitle: 'Our Team',
    teamSubtitle: 'Meet the people behind our dealership',
    members: [
      { name: 'Manager Name', role: 'General Manager' },
      { name: 'Sales Rep Name', role: 'Sales' },
      { name: 'Advisor Name', role: 'Customer Service' },
    ],
  },
};
